import { useEffect } from "react";

/**
 * Per-page <title> + <meta name="description"> + open-graph tags.
 * Restores previous values on unmount so navigating away doesn't leak state.
 */
export default function usePageMeta({ title, description, ogImage } = {}) {
    useEffect(() => {
        const prevTitle = document.title;
        const descTag = document.querySelector('meta[name="description"]');
        const ogTitleTag = document.querySelector('meta[property="og:title"]');
        const ogDescTag = document.querySelector('meta[property="og:description"]');
        const ogImageTag = document.querySelector('meta[property="og:image"]');
        const prev = {
            desc: descTag?.getAttribute("content"),
            ogTitle: ogTitleTag?.getAttribute("content"),
            ogDesc: ogDescTag?.getAttribute("content"),
            ogImage: ogImageTag?.getAttribute("content"),
        };

        const ensure = (selector, attr, key, value) => {
            let tag = document.querySelector(selector);
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute(attr, key);
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", value);
            return tag;
        };

        if (title) document.title = title;
        if (description) ensure('meta[name="description"]', "name", "description", description);
        if (title) ensure('meta[property="og:title"]', "property", "og:title", title);
        if (description) ensure('meta[property="og:description"]', "property", "og:description", description);
        if (ogImage) ensure('meta[property="og:image"]', "property", "og:image", ogImage);

        return () => {
            document.title = prevTitle;
            if (descTag && prev.desc != null) descTag.setAttribute("content", prev.desc);
            if (ogTitleTag && prev.ogTitle != null) ogTitleTag.setAttribute("content", prev.ogTitle);
            if (ogDescTag && prev.ogDesc != null) ogDescTag.setAttribute("content", prev.ogDesc);
            if (ogImageTag && prev.ogImage != null) ogImageTag.setAttribute("content", prev.ogImage);
        };
    }, [title, description, ogImage]);
}
